import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { postActivity } from './api';
import { ActivityDTO } from './dto/ActivityDTO';

function usePostActivity() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation((activity: ActivityDTO) => postActivity(activity), {
    onSuccess: () => {
      queryClient.invalidateQueries('activity');
    },
    onError: error => {
      toast.error(t('message.title.error.post.activity'));
    },
  });
  return { postActivity: mutate, isLoadingPostActivity: isLoading };
}

export default usePostActivity;
